// extracted by mini-css-extract-plugin
export var deleteModal = "_ix-0";